// extracted by mini-css-extract-plugin
export var legendIndicator = "_eh-1";
export var legendRight = "_eh-0";